export default __webpack_public_path__ + "static/media/btn_close_default.b532980d.svg";